import { Model, type ModelProps } from '@/infra/model'
import { Id } from '@/infra/id'
import { unixEpoch } from '@/utils/date-util'
import { TeamRole } from './TeamRole'
import { Team } from './Team'
import { computed, observable } from 'mobx'
import { generateAvatarFallback } from '@/utils/image-util'

export type PendingTeamMemberProps = ModelProps<PendingTeamMember>

export class PendingTeamMember extends Model<PendingTeamMember> {
  @observable accessor workspaceId = Id.none
  @observable accessor dateCreated: Date = unixEpoch()
  @observable accessor dateModified: Date = unixEpoch()
  @observable accessor email = ''
  @observable accessor teamRole = TeamRole.none
  @observable accessor expires: Date = unixEpoch()

  @observable accessor team = Team.none

  @computed
  get avatar() {
    return generateAvatarFallback(
      this.email,
      this.team.workspace.branding.colors.primary,
    )
  }
}
